<div #cropper class="border-cropper">
  <img alt="initial-image"/>
  <input type="file" name="slim[]" accept="image/jpeg,image/png,image/gif,image/bmp,text/xml"/>
  <!--'text/xml' is needed because Slim doesn't detect properly the data type of files w/o extension (for ex. https://my-url.com/image/blob)-->
</div>
